import AnimatedLayout from 'components/layouts/animated-layout';
import { SettingsContentHeader } from 'components/layouts/settings-workspace/settings-workspace';
import HelmetTabComponent from 'components/helmet-tab/helmet-tab';
import { TwoVeify } from 'features/profile';

const SecurityTab = () => {
    return (
        <AnimatedLayout>
            <HelmetTabComponent title="تایید دومرحله‌ای" />

            <SettingsContentHeader
                title="تایید دومرحله‌ای"
                description="یک لایه امنیتی اضافه برای ورود به حساب کاربری خود فعال کنید."
            />

            <TwoVeify />
        </AnimatedLayout>
    );
};

export default SecurityTab;
